import script from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"

import "./PhoneLogin.vue?vue&type=style&index=0&id=43f00ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f00ba4"]])

export default __exports__